module.exports = __webpack_public_path__ + "static/EAD-01-e9675d0660af0f72e666a1c39b67beac.png";